import { isEmpty } from "lodash";
import { put, takeLatest } from "redux-saga/effects";
import { SAVE_ANONYMOUS_INFO, SAVE_VROOM_TOKEN, SET_ANONYMOUS_INFO, SET_VROOM_TOKEN } from "../actions/type";

function* saveAnonymousInfo({ payload }) {
    const { name, id } = payload
    yield put({
        type: SET_ANONYMOUS_INFO,
        payload: {
            anonymousInfo: { name, id }
        }
    })
    localStorage.setItem('anonymousInfo', JSON.stringify({ name, id }))
}

function* saveVroomToken({ payload }) {
    const { jwt } = payload
    if (!isEmpty(jwt)) {
        yield put({
            type: SET_VROOM_TOKEN,
            payload: {
                vroomToken: jwt
            }
        })
    }
}

function* lobby() {
    yield takeLatest(SAVE_ANONYMOUS_INFO, saveAnonymousInfo)
    yield takeLatest(SAVE_VROOM_TOKEN, saveVroomToken)
}

export default lobby